<ng-container *ngIf="!!header">
  <div class="container p-sm-0" data-test="header">
    <div class="header-container d-flex flex-nowrap py-3 py-lg-2">
      <div *ngIf="!!header.image?.url" class="col header-logo-container d-flex flex-grow-0 align-items-center justify-content-center">
        <flo-image class="header-logo object-fit-cover" [image]="header.image"></flo-image>
      </div>
      <div class="col d-flex flex-column justify-content-center mx-2 mx-md-3 p-0">
        <!-- Header Drill Through Links -->
        <div *ngIf="!!header.drillThroughLinks.length" class="header-drill_through_links d-flex flex-wrap gap-1" data-test="header-drill-through-links">
          <span *ngFor="let item of header.drillThroughLinks; index as i; trackBy: trackById">
            <ng-container *ngIf="item.type === 'link'; else showText">
              <a
                floAnalytics
                [analyticsProperties]="item.analytics"
                [floCustomLink]="item.url"
                class="primary-color-text text-nowrap overtext">{{ item.title }}
              </a>
            </ng-container>
            <ng-template #showText>
              <span class="text-nowrap">{{ item.text }}</span>
            </ng-template>
          </span>
        </div>


        <!-- Header Title - show/hide mobile title and desktop title depending on breakpoint-->
        <h1 class="h4 d-sm-none m-0 header-title" data-test="header-title-mobile">{{ header.title.text }}</h1>

        <div class="d-flex flex-row align-items-center d-none d-sm-flex">
          <h1 class="h1 header-title" data-test="header-title-desktop">{{ header.title.text }}</h1>
          <div class="mx-1" *ngIf="!!header.badges">
            <flo-badge *ngFor="let badge of header.badges" [badge]="badge"></flo-badge>
          </div>
        </div>

        <!-- Header Summary -->
        <div *ngIf="!!header.summary" class="header-summary d-flex flex-wrap gap-2" data-test="header-summary">
          <span *ngFor="let item of header.summary?.items; index as i; trackBy: trackById">
            <ng-container *ngIf="item.type === 'link'; else showText">
              <a
                floAnalytics
                [analyticsProperties]="item.analytics"
                [floCustomLink]="item.url"
                [ngClass]="item.style"
                class="primary-color-text text-decoration-underline text-nowrap">{{ item.title }}
              </a>
            </ng-container>
            <ng-template #showText>
              <span class="text-nowrap" [ngClass]="item.style">{{ item.text }}</span>
            </ng-template>
          </span>
        </div>
      </div>

      <div *ngIf="header.cta1" class="responsive-button-icon col d-flex flex-grow-0 align-items-center justify-content-end">
        <flo-link
          tagName="Button"
          [link]="header.cta1"
          (linkClick)="handleLinkClick($event)"
          [clientQueryParams]="redirect"
        ></flo-link>
      </div>
    </div>
    <div class="d-sm-none mx-1" *ngIf="!!header.badges">
      <flo-badge *ngFor="let badge of header.badges" [badge]="badge"></flo-badge>
    </div>
  </div>
</ng-container>
